document.addEventListener('DOMContentLoaded', () => {
  const email = document.querySelector('#contact_email');
  const confirm = document.querySelector('#contact_email_confirm');
  const errorEl = document.querySelector('#EmailConfirmError');

  if (!email || !confirm) return;

  const form = email.closest('form');
  if (!form) return;

  const setError = (msg) => {
    confirm.setCustomValidity(msg || '');
    if (!errorEl) return;

    if (msg) {
      errorEl.textContent = msg;
      errorEl.style.display = 'block';
    } else {
      errorEl.textContent = '';
      errorEl.style.display = 'none';
    }
  };

  const validate = () => {
    const a = (email.value || '').trim();
    const b = (confirm.value || '').trim();

    if (!a || !b) {
      setError('');
      return true;
    }

    if (a.toLowerCase() !== b.toLowerCase()) {
      setError('Please confirm the same email address.');
      return false;
    }

    setError('');
    return true;
  };

  email.addEventListener('input', validate);
  confirm.addEventListener('input', validate);

  // --- NEW: "How did you hear about us?" -> show "Please specify" only when Other is selected ---
  const heardAboutSelect = document.getElementById('heard_about');
  const heardAboutOtherRow = document.getElementById('heard_about_other_row');
  const heardAboutOtherInput = document.getElementById('heard_about_other');

  function updateHeardAboutOther() {
    if (!heardAboutSelect || !heardAboutOtherRow || !heardAboutOtherInput) return;

    const isOther = heardAboutSelect.value === 'Other';

    if (isOther) {
      heardAboutOtherRow.style.display = '';
      heardAboutOtherInput.disabled = false;
      heardAboutOtherInput.required = true;
    } else {
      heardAboutOtherRow.style.display = 'none';
      heardAboutOtherInput.required = false;
      heardAboutOtherInput.value = '';
      heardAboutOtherInput.disabled = true;
    }
  }

  if (heardAboutSelect) {
    heardAboutSelect.addEventListener('change', updateHeardAboutOther);
    updateHeardAboutOther(); // initialize on load
  }
  // --- END NEW ---

  form.addEventListener('submit', (e) => {
    // 1) confirm email check
    if (!validate()) {
      e.preventDefault();
      confirm.reportValidity();
      confirm.focus();
      return;
    }

    // 2) "Other" specify check (in case browser required doesn't catch it)
    if (heardAboutSelect && heardAboutOtherInput) {
      const isOther = heardAboutSelect.value === 'Other';
      const otherVal = (heardAboutOtherInput.value || '').trim();
      if (isOther && !otherVal) {
        e.preventDefault();
        heardAboutOtherInput.required = true;
        heardAboutOtherInput.reportValidity();
        heardAboutOtherInput.focus();
        return;
      }
    }

    // 一致したら confirm は送信しない（disabledは送信対象外）
    confirm.disabled = true;
  });
});